module.exports = __webpack_public_path__ + "images/end_point.cb6ac03ff0bae6f2800e3703f66d4a9b.svg";